<app-billing-header></app-billing-header>
<div class="content">
    <h2 class="mat-dialog-title" [ngClass]="is_ignite ? 'custom-billing-heading' : 'popup-heading'">
        Billing Address
    </h2>

    <form [formGroup]="billingForm" class="billing-form" (ngSubmit)="billingInfo()">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="first_name" placeholder="Enter first name" required />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="last_name" placeholder="Enter last name" required />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Address Line 1</mat-label>
            <input matInput formControlName="address_1" placeholder="Enter address" required />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Address Line 2</mat-label>
            <input matInput formControlName="address_2" placeholder="Enter address (optional)" />
        </mat-form-field>
        <div class="half-width">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>City</mat-label>
                <input matInput formControlName="city" placeholder="Enter city" required />
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
            <mat-label>Country</mat-label>
            <mat-select formControlName="country" required>
                <mat-option *ngFor="let country of countries" [value]="country.code">
                {{ country.name }}
                </mat-option>
            </mat-select>
            </mat-form-field>
        </div>

        <div class="half-width">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>State</mat-label>
                <input matInput formControlName="state" placeholder="Enter state" required />
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Zip / Postal Code</mat-label>
                <input matInput formControlName="zip_code" placeholder="Enter zip code" required />
            </mat-form-field>
        </div>
        <div class="action-buttons" align="end">
            <button class="save" mat-flat-button
                [ngStyle]="{ 'background-color': 'var(--primary-color)', 'color': 'var(--light-color)' }" type="submit"
                [disabled]="processing" (click)="billingInfo()">
                {{ saveButtonText }}
                <span class="spinner-container" *ngIf="processing">
                    <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
                </span>
            </button>
        </div>
    </form>
</div>